import axios, { AxiosError } from 'axios';
import { getLogger } from '@/shared/infrastructure/datadog';

type CatchErrorProps = {
  error: any;
  onRequestError: (error: AxiosError) => void;
};

export const catchError = ({ error, onRequestError }: CatchErrorProps) => {
  if (axios.isAxiosError(error)) {
    onRequestError(error);
    return;
  }

  getLogger().error(error);
};
